var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quotes"},[_c('h1',[_vm._v(_vm._s(_vm.msg)+" You're viewing some cool affirmation quotes")]),_c('a',{attrs:{"href":"#/home"}},[_vm._v("Back home")]),_vm._l((_vm.quotes),function(quote){return (!_vm.isLoading)?_c('p',[_vm._v(_vm._s(quote.quote))]):_vm._e()})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46950830","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quotes.vue
// module id = null
// module chunks = 